module.exports = __webpack_public_path__ + "static/img/develop2.94178c46.png";